export enum DefaultChannels {
	App = "app",
	Totem = "totem",
	Marketplace = "marketplace",
	Ecommerce = "ecommerce",
}
